<template>
  <div class="match-announcement">
    <div class="header">
<!--      <van-swipe :autoplay="3000" indicator-color="white">-->
<!--        <van-swipe-item v-for="(item, index) in banners" :key="index">-->
<!--        </van-swipe-item>-->
<!--      </van-swipe>-->
      <div class="my-swipe">
        <van-image :src="imgView(match.backgroundImage2)" width="100%" fit="contain"></van-image>
        <div class="icon" @click="share()"><img src="http://images.snsports.cn/fx.png" /> 分享</div>
      </div>
      <div class="match">
        <div class="info">
          <div class="left">
            <van-image :src="(match.icon && match.icon.length === 28) ? imgView(match.icon) : ''" width="36px" height="36px"></van-image>
            <div class="care">
              + 关注
            </div>
          </div>
          <div class="right">
            <div class="title">
              <span>{{match.chineseName}}</span>
            </div>
            <div class="address">
              时间：{{ getFormatDate(match.beginDate) }} - {{ getFormatDate(match.endDate) }}
            </div>
            <div class="address">
              地区：{{`${(match.province && match.province.name || '') + ' ' + (match.district && match.district.name || '')+ ' ' + (match.location && match.location.address || '')}`}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-tabs background="#f5f5f5" @click="changeAction" v-model="active">
      <van-tab name="games" title="赛程">
        <div style="padding: 12px 12px 0 12px;">
          <match-schedule :match-id="matchId"></match-schedule>
        </div>
      </van-tab>
      <van-tab name="score" title="积分">
        <div style="padding: 12px 12px 0 12px;">
          <score :match-id="matchId"></score>
        </div>
      </van-tab>
      <van-tab name="rank" title="名次">
        <div style="padding: 12px 12px 0 12px;">
          <ranking :match-id="matchId"></ranking>
        </div>
      </van-tab>
      <van-tab name="teams" title="名册">
        <div style="padding: 12px 12px 0 12px;">
          <team-list :match-id="matchId"></team-list>
        </div>
      </van-tab>
    </van-tabs>
    <div style="height: 30px;"></div>
    <van-overlay :show="show" @click="show = false">
      <div class="down-img" @click="downLoadImg">保存海报</div>
    </van-overlay>
    <div v-show="show" class="canvas" id="firstCanvas">
      <div class="img" :style="{'background-image': banners[0] ? 'url(' + imgView(banners[0].image) + ')' : ''}" />
      <div class="info">
        <div class="left">
          <van-image :src="(match.icon && match.icon.length === 28) ? imgView(match.icon) : ''" width="36px" height="36px"></van-image>
        </div>
        <div class="right">
          <div class="title">
            <span>{{match.chineseName}}</span>
          </div>
          <div class="address">
            <img style="width: 16px; height: 16px" src="https://images.snsports.cn/FsyXGcBp4-jm4dO2jW1AZIUjGFGY" />
            {{ getFormatDate(match.beginDate) }} - {{ getFormatDate(match.endDate) }}
          </div>
          <div class="address">
            <img style="width: 16px; height: 16px" src="https://images.snsports.cn/FhqMTCc6JYBSUMKkgkz0HlBxsG2q" />
            {{`${(match.province && match.province.name || '') + ' ' + (match.district && match.district.name || '')+ ' ' + (match.location && match.location.address || '')}`}}
          </div>
        </div>
      </div>
      <div style="height: 1px; background-color: #E5E5E5; margin: 20px 16px 0"></div>
      <div style="width: 200%; box-sizing: border-box; padding: 0 32px; display: flex; justify-content: space-between; transform: scale(0.5); transform-origin: 0 0">
        <div style="padding-top: 76px">
          <img style="width: 158px; height: 64px;" src="../../assets/bmbLogo.png" />
          <div style="font-size: 22px; color: #999999; margin-top: 10px">长按识别二维码 查看更多比赛详情</div>
        </div>
        <div id="qrcode" style="width: 128px; height: 128px; transform-origin: 0 0; border: 18px #F6F7F9 solid; border-radius: 8px; margin-top: 48px"></div>
      </div>
    </div>
<!--    <canvas v-if="show" id="firstCanvas" class="canvas" width="590" height="792"></canvas>-->
<!--    <div id="qrcode" style="width: 200px; height: 200px; position: fixed; top: -249px"></div>-->
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem, Image as VanImage, Tabs, Tab, Overlay, Toast } from 'vant';
Vue.use(Swipe).use(SwipeItem).use(VanImage).use(Tabs).use(Tab).use(Overlay).use(Toast);
import {getBMMatchInfo, getHome} from "@/api/match";
import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"

import MatchSchedule from "@/views/match-announcement/components/MatchSchedule";
import Score from "@/views/match-announcement/components/Score";
import Ranking from "@/views/match-announcement/components/Ranking";
import TeamList from "@/views/match-announcement/components/TeamList";

import {DateUtil, QNImageUtil} from "@/utils";

export default {
  name: "index",
  components: {
    MatchSchedule,
    Score,
    Ranking,
    TeamList
  },
  data() {
    return {
      banners: [],
      match: {},
      active: 'games',
      show: false,
      matchId: ''
    }
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    if (this.matchId) {
      this.getHome()
      this.getBMMatchInfo()
    } else {
      Toast.fail('缺少赛事Id')
    }
  },
  methods: {
    changeAction(name) {
      this.active = name
    },
    getHome() {
      getHome().then(res => {
        if (res) {
          this.banners = res.data.banners
        }
      })
    },
    getBMMatchInfo() {
      const params = {
        matchId: this.matchId
      }
      getBMMatchInfo(params).then(res => {
        if (res) {
          this.match = res.data.match
        }
      })
    },
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
    getFormatDate(date) {
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    downLoadImg() {
      html2canvas(document.querySelector("#firstCanvas"), {
        width: 295,
        height: 396,
        useCORS: true,
        scale: 4
      }).then((canvas) => {
        canvas.toBlob(blob => {
          // 创建一个 a 标签
          const a = document.createElement('a')
          // 设置 a 标签的下载文件名
          a.download = `${this.match.chineseName || 'match'}.png`
          // 设置 a 标签的跳转路径为 文件流地址
          a.href = URL.createObjectURL(blob)
          // 手动触发 a 标签的点击事件
          a.click()
          // 移除 a 标签
          a.remove()
        })
      })
    },
    getFormatTime(date) {
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    share() {
      this.show = true
      const qrcode = document.querySelector("#qrcode")
      qrcode.innerHTML = ''
      new QRCode(qrcode, {
        text: 'https://match-h5-dev.snsports.cn/#/match?matchId=' + this.matchId,
        width: 128,
        height: 128
      })
    },
    drawing() {
      const ctx = document.getElementById("firstCanvas").getContext("2d")
      ctx.fillStyle = '#ffffff' // 默认白色
      ctx.fillRect(0, 0, 590, 792)
      const img = new Image()
      img.src = this.imgView(this.banners[0].image)
      img.setAttribute('crossOrigin', 'anonymous')
      img.onload = function () {
        ctx.drawImage(img, 0, 0, 590, 242)
      }
      const icon = new Image()
      icon.src = this.imgView(this.match.icon)
      icon.setAttribute('crossOrigin', 'anonymous')
      icon.onload = function () {
        ctx.drawImage(icon, 36, 290, 72, 72)
      }
      let txt = this.match.chineseName
      ctx.textBaseline = 'top'
      ctx.fillStyle = '#282828'
      ctx.font = '500 32px sans-serif'
      let index = 0
      setText(txt)
      function setText(txt) {
        if (ctx.measureText(txt).width < 218) {
          ctx.fillText(txt, 122, 296 + index * 40)
        } else {
          ctx.fillText(txt.slice(0, 13), 122, 296 + index * 40)
          index++
          setText(txt.slice(13))
        }
      }
      const timeImg = new Image()
      timeImg.src = 'https://images.snsports.cn//FsyXGcBp4-jm4dO2jW1AZIUjGFGY'
      timeImg.setAttribute('crossOrigin', 'anonymous')
      timeImg.onload = function () {
        ctx.drawImage(timeImg, 118, 410, 32, 32)
      }
      const areaImg = new Image()
      areaImg.src = 'https://images.snsports.cn//FhqMTCc6JYBSUMKkgkz0HlBxsG2q'
      areaImg.setAttribute('crossOrigin', 'anonymous')
      areaImg.onload = function () {
        ctx.drawImage(areaImg, 118, 454, 32, 32)
      }
      const timeTxt = this.getFormatTime(this.match.beginDate) + ' ~ ' + this.getFormatTime(this.match.endDate)
      ctx.fillStyle = '#8C8C8C'
      ctx.font = 'normal 28px sans-serif'
      ctx.fillText(timeTxt, 158, 412)
      const area = this.match.province.name + ' - ' + this.match.city.name + ' - ' + this.match.district.name
      ctx.fillText(area, 158, 456)
      ctx.beginPath()
      ctx.moveTo(32, 534)
      ctx.lineTo(558, 534)
      ctx.closePath()
      ctx.strokeStyle = '#E5E5E5' // 绘制的颜色(边框)
      ctx.lineWidth = 1 // 绘制的宽度 (边框)
      ctx.stroke();
      const bmbLogo = new Image()
      bmbLogo.src = 'https://images.snsports.cn/bmb.png'
      bmbLogo.setAttribute('crossOrigin', 'anonymous')
      bmbLogo.onload = function () {
        ctx.drawImage(bmbLogo, 32, 612, 158, 64)
      }
      ctx.font = 'normal 22px sans-serif'
      ctx.fillStyle = '#999999'
      ctx.fillText('长按识别二维码 查看更多比赛详情', 32, 686)
      const qrcode = document.querySelector("#qrcode")
      qrcode.innerHTML = ''
      new QRCode(qrcode, {
        text: 'https://match-h5-dev.snsports.cn/#/match?matchId=' + this.matchId,
        width: 200,
        height: 200
      })
      html2canvas(document.querySelector("#qrcode"), {
        width: 200,
        height: 200,
        scale: 1
      }).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png")
        const code = new Image()
        code.src = dataURL
        code.onload = function () {
          ctx.drawImage(code, 414, 600, 128, 128)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.match-announcement {
  position: relative;
  background-color: #F5F5F5;
  min-height: 100vh;
  .header {
    background-color: #ffffff;
    padding: 20px 12px 0 12px;
    .my-swipe {
      position: relative;
      .icon {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 3px 10px;
        box-sizing: border-box;
        top: 12px;
        right: 12px;
        width: 60px;
        height: 24px;
        background: rgba(25,25,25,0.8);
        border-radius: 12px;
        font-size: 12px;
        color: #fff;
        img{
          width: 12px;
          height: 11px;
          margin-right: 1px;
        }
      }
    }
    .match {
      background-color: #fff;
      border-radius: 4px 4px 8px 8px;
      margin-bottom: 12px;
      .info {
        margin: 0 16px;
        padding: 16px 0 12px 0;
        display: flex;
        flex-flow: row;
        .left {
          text-align: center;
          width: 44px;
          .care {
            width: 44px;
            height: 20px;
            border-radius: 2px;
            background-color: #BEF002;
            color: #191919;
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            margin-top: 12px;
          }
        }
        .right {
          width: calc(100% - 36px);
          padding-left: 12px;
          box-sizing: border-box;
          .title {
            height: 48px;
            font-size: 18px;
            font-weight: 500;
            color: #191919;
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .address {
            margin-top: 4px;
            font-size: 14px;
            color: #999999;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
          }
          .size-count {
            margin-top: 4px;
            display: flex;
            flex-flow: row;
            font-size: 12px;
            color: #474747;
            .count {
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
  .down-img {
    position: fixed;
    top: 78%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 211px;
    height: 40px;
    background: #BEF002;
    border-radius: 25px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #191919;
    text-align: center;
    line-height: 40px;
  }
  .canvas {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    transform-origin: 0 0;
    z-index: 999999999;
    //background-color: #ffffff;
    transition:all .5s;

    background-color: #fff;
    width: 295px;
    height: 396px;
    border-radius: 8px;
    .img {
      width: 295px;
      height: 121px;
      background-size: 100%;
    }
    .info {
      margin: 0 16px;
      padding: 16px 0 12px 0;
      display: flex;
      flex-flow: row;
      .left {
        text-align: center;
        width: 44px;
      }
      .right {
        width: calc(100% - 36px);
        padding-left: 12px;
        box-sizing: border-box;
        .title {
          height: 48px;
          font-size: 18px;
          font-weight: 500;
          color: #191919;
          overflow:hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .address {
          margin-top: 4px;
          font-size: 14px;
          color: #999999;
          overflow:hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow:ellipsis;
          display: flex;
          align-items: center;
        }
        .size-count {
          margin-top: 4px;
          display: flex;
          flex-flow: row;
          font-size: 12px;
          color: #474747;
          .count {
            margin-left: 12px;
          }
        }
      }
    }
  }
}
</style>